import { render } from "./header-buttons.vue?vue&type=template&id=5b114dcb"
import script from "./header-buttons.vue?vue&type=script&setup=true&lang=js"
export * from "./header-buttons.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/whatsapp/pages/chats/components/header-buttons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b114dcb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b114dcb', __exports__)) {
    console.log('reload')
    api.reload('5b114dcb', __exports__)
  }
  
  module.hot.accept("./header-buttons.vue?vue&type=template&id=5b114dcb", () => {
    console.log('re-render')
    api.rerender('5b114dcb', render)
  })

}


export default __exports__